import { render, staticRenderFns } from "./playlist-tracks-editor.vue?vue&type=template&id=19072593&scoped=true&"
import script from "./playlist-tracks-editor.vue?vue&type=script&lang=ts&"
export * from "./playlist-tracks-editor.vue?vue&type=script&lang=ts&"
import style1 from "./playlist-tracks-editor.vue?vue&type=style&index=1&id=19072593&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19072593",
  null
  
)

export default component.exports